import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { getLoaders } from '../../selectors';
import { updateSurveys } from '../../actions';
import { downloadASQReport } from 'actions/download';
import ASQSurveysTable from '../../components/asqs/ASQSurveysTable';
import { linkWithParams } from 'routes';
import { withScrollPosition } from 'utils/scrollHelpers';

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    download: state.surveys.download,
    isLoading: getLoaders(state, ['SURVEYS_FILTER', 'SURVEYS']),
    isFetching: state.surveys.isFetching,
    location: state.router.location,
    meta: state.meta.surveys,
    page: state.meta.surveys.page,
    totalPages: state.meta.surveys.totalPages,
    surveys: state.surveys.surveys,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadMore: (page) => {
      dispatch(updateSurveys({page: page}))
    },
    onASQLink: (playerId, surveyId, from) => {
      const path = {
        pathname: linkWithParams('asq', { player_id: playerId, id: surveyId }),
        state: withScrollPosition(from),
      };
      dispatch(push(path));
    },
    onDownloadASQReport: (id) => {
      dispatch(downloadASQReport(id, { id }));
    },
    onPlayerDetails: (playerId, surveyId, from) => {
      const path = {
        pathname: linkWithParams('player', { player_id: playerId, id: surveyId }),
        state: withScrollPosition(from),
      };
      dispatch(push(path));
    },
    onSortChange: (sort, order) => {
      dispatch(updateSurveys({sort, order, init: true}, {source: 'init'}))
    },
  }
}

const ASQSurveysContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ASQSurveysTable)

export default ASQSurveysContainer;
